class PackDrawer extends HTMLElement {
    constructor() {
        super();

        const buildPackButton = document.querySelector('.js-bundle-pack');
        const buildPackButtons = document.querySelectorAll('.js-bundle-block');
        this.buttonPackSizes = this.querySelectorAll('.bundle-pack-drawer-pack-size-button');
        this.styleSelect = this.querySelector('.style-dropdown');
        this.sizeSelect = this.querySelector('.size-dropdown');
        this.bundleATC = this.querySelector('.js-bundle-pack-act');
        this.bundleSelectedItem = this.querySelector('.bundle-pack-drawer-selected-item-wrap');
        this.bundleAddedItems = this.querySelector('.bundle-pack-drawer-added-items');
        this.selections = this.querySelectorAll('select');
        this.packIcons = this.querySelectorAll('.bundle-pack-drawer-icon');
        this.packIconsWrap = this.querySelector('.bundle-pack-drawer-icons');
        this.packBottom = this.querySelector('.bundle-pack-drawer-bottom');
        this.pairWrapContent = this.querySelector('.bundle-pack-drawer-pair-wrap-content');
        this.pairTitle = this.querySelector('.bundle-pack-drawer-pair-title');

        if(buildPackButton){
            buildPackButton.addEventListener('click', ()=>{
                this.classList.add('active');
            });
        }
        
        if(buildPackButtons.length > 0){
            buildPackButtons.forEach((buildPackButton) => {
                buildPackButton.addEventListener('click', (e)=>{
                    this.classList.add('active');
                    const packSize = e.target.getAttribute('data-packsize');

                    if(packSize){console.log('clicked');
                        for (let i = 0; i < 3; i++) {
                            this.querySelector('.bundle-pack-drawer-pack-size-button[data-type="minus"]').click();
                        }

                        if(parseInt(packSize) == 3){
                            this.querySelector('.bundle-pack-drawer-pack-size-button[data-type="plus"]').click();
                        }else if(parseInt(packSize) == 5){
                            for (let i = 0; i < 3; i++) {
                                this.querySelector('.bundle-pack-drawer-pack-size-button[data-type="plus"]').click();
                            }
                        }
                    }
                });
            })
        }

        this.addEventListener('click', (event) => {
            if(event.target.classList.contains('bundle-pack-drawer-popup-close') || event.target.closest('.bundle-pack-drawer-popup-close') || event.target.classList.contains('bundle-pack-drawer-background')){
                this.classList.remove('active');
            }
        })

        this.buttonPackSizes.forEach((buttonPackSize) => {
            buttonPackSize.addEventListener('click', this.buttonButtonClick.bind(this))
        })

        this.selections.forEach((selection) => {
            selection.addEventListener('change', this.sectionChange.bind(this))
        })

        this.packIcons.forEach((packIcon) => {
            packIcon.addEventListener('click', this.packIconChange.bind(this))
        })

        this.bundleATC.addEventListener('click', this.bundleItemAdd.bind(this))

        this.addEventListener('click', this.packClickEvents.bind(this))
    }

    formatMoney(cents, format = "{{amount}}") {
        let value = (cents / 100).toFixed(2); // Convert to dollars
        let formatted = value;

        if (format === "{{amount_no_decimals}}") {
            formatted = Math.round(cents / 100).toString();
        } else if (format === "{{amount_with_comma_separator}}") {
            formatted = value.replace(/\./, ',');
        } else if (format === "{{amount_no_decimals_with_comma_separator}}") {
            formatted = Math.round(cents / 100).toString().replace(/\./, ',');
        } else if (format === "{{amount_with_apostrophe_separator}}") {
            formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, "'"); // 1'234.56
        } else {
            formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // 1,234.56
        }

        return formatted;
    }

    buttonButtonClick(event){
        const eventTarget = event.target.classList.contains('bundle-pack-drawer-pack-size-button') ? event.target:event.target.closest('.bundle-pack-drawer-pack-size-button');
        const clickType = eventTarget.getAttribute('data-type');
        const wideActiveItem = this.querySelector('.wide-active');
        const prevItem = wideActiveItem.previousElementSibling;
        const prevPItem = prevItem.previousElementSibling;
        const nextItem = wideActiveItem.nextElementSibling;
        const nextNItem = nextItem.nextElementSibling;

        if(clickType == 'plus'){
            if(nextNItem){
                prevItem.classList.remove('active');
                wideActiveItem.classList.remove('wide-active');
                nextItem.classList.add('wide-active');
                nextNItem.classList.add('active');
            }
        }else{
            if(prevPItem){
                nextItem.classList.remove('active');
                wideActiveItem.classList.remove('wide-active');
                prevItem.classList.add('wide-active');
                prevPItem.classList.add('active');
            }
        }

        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();

        if(currentProduct && currentVariant){
            if(this.querySelector('.bundle-pack-drawer-selected-item')){
                this.updatePackSelectedItem(currentVariant, currentProduct);
            }
        }
        
        this.updateBottomWidget();
    }

    bundleItemAdd(event){
        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();

        let itemHtml = `<div class="bundle-pack-drawer-added-item" data-productid="${currentProduct.id}" data-variantid="${currentVariant.id}" data-price="${currentVariant.price}">`;
        let featuredImage = currentProduct.featured_image;
        itemHtml += `<div class="bpd-ai-c-wrap"><div class="bpd-ai-image">
                        <img src="${featuredImage}&width=64" alt="${currentProduct.title}"  width="64" height="64">
                    </div>`;

        itemHtml += `<div class="bpd-ai-content">
                        <div class="bpd-saiiw-title">${currentProduct.title}</div>
                        <div class="bpd-ai-options">${currentProduct.options[0]}:${currentVariant.option1}</div>
                    </div></div>`;

        itemHtml += `<div class="bpd-ai-close">
                        <button class="bpd-ai-remove"><img src="https://cdn.shopify.com/s/files/1/0572/5700/1026/files/trash-gray.svg?v=1754573982" alt="close"></button>
                    </div>`;

        itemHtml += '</div>';

        event.target.classList.add('hidden');
        this.bundleSelectedItem.innerHTML = '';
        // this.packIconsWrap.classList.add('hidden');

        this.bundleAddedItems.insertAdjacentHTML('beforeend', itemHtml);
        this.updateBottomWidget();
    }

    packClickEvents(event){
        const removeButton = event.target.classList.contains('bpd-ai-remove')?event.target.classList.contains('bpd-ai-remove'):event.target.closest('.bpd-ai-remove');
        const bpCheckoutButton = event.target.classList.contains('js-bp-checkout');

        if(removeButton){
            removeButton.closest('.bundle-pack-drawer-added-item').remove();
            this.updateBottomWidget();
        }else if(bpCheckoutButton){
            event.target.setAttribute('disabled', 'disabled');
            this.bpCheckout();
        }
    }

    bpCheckout(){
        let items = [];
        const addedItems = this.querySelectorAll('.bundle-pack-drawer-added-item');

        addedItems.forEach((addedItem) => {
            const vid = parseInt(addedItem.getAttribute('data-variantid'));

            items.push({'id': vid, 'quantity': 1});
        });

        fetch(`${window.Shopify.routes.root}` + 'cart/clear.js', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
        }).then(response => {
            let formData = {
                'items': items
            };

            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(response => {
                window.location.href = '/checkout';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        });
    }

    sectionChange(event){
        const selection = event.target;
        const selectionDataType = selection.getAttribute('data-type');
        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();
        
        // this.packIconsWrap.classList.remove('hidden');
        this.bundleATC.classList.remove('hidden');
        if(currentVariant.available){
            this.bundleATC.removeAttribute('disabled');
            this.bundleATC.innerText = 'Add to Bundle';
        }else{
            this.bundleATC.setAttribute('disabled', 'disabled');
            this.bundleATC.innerText = 'Out of Stock';
        }
        if(currentProduct && currentVariant){
            this.updatePackSelectedItem(currentVariant, currentProduct);
        }
    }

    packIconChange(event){
        const selection = event.target;
        const selectedPackIcon = selection.classList.contains('bundle-pack-drawer-icon')?selection:selection.closest('.bundle-pack-drawer-icon');
        const selectionProductId = selectedPackIcon.getAttribute('data-productid');

        this.packIcons.forEach((packIcon) => {
            packIcon.classList.remove('active');
        });

        selectedPackIcon.classList.add('active');
        this.bundleATC.classList.remove('hidden');

        const currentVariant = this.getSelectedVariant();
        const currentProduct = this.getSelectedProduct();

        if(currentVariant.available){
            this.bundleATC.removeAttribute('disabled');
            this.bundleATC.innerText = 'Add to Bundle';
        }else{
            this.bundleATC.setAttribute('disabled', 'disabled');
            this.bundleATC.innerText = 'Out of Stock';
        }
        
        if(currentProduct && currentVariant){
            this.updatePackSelectedItem(currentVariant, currentProduct);
        }
    }

    updatePackSelectedItem(currentVariant, currentProduct){
        this.updateItemWrap = this.querySelector('.bundle-pack-drawer-selected-item-wrap');
        let itemHtml = '<div class="bundle-pack-drawer-selected-item">';
        let featuredImage = currentProduct.featured_image;
        itemHtml += `<div class="bpd-siw-image">
                        <img src="${featuredImage}&width=200" alt="${currentProduct.title}" 
                             srcset="${featuredImage}&width=120 120w, ${featuredImage}&width=150 150w, ${featuredImage}&width=175 175w, ${featuredImage}&width=200 200w" width="200" height="200">
                    </div>`;

        itemHtml += `<div class="bpd-siw-content">
                        <div class="bpd-siw-title">${currentProduct.title}</div>
                        <div class="bpd-siw-options">${currentVariant.title}</div>
                        <div class="bpd-siw-prices">
                            <div class="bpd-siw-compare-price">$${this.formatMoney(currentVariant.price, "{{amount}}")}</div>
                            <div class="bpd-siw-price">$${this.formatMoney(this.getDiscountedPrice(currentVariant.price), "{{amount}}")}</div>
                        </div>
                    </div>`;

        itemHtml += '</div>';

        this.updateItemWrap.innerHTML = itemHtml;
    }

    updateBottomWidget(){
        const addedItems = this.querySelectorAll('.bundle-pack-drawer-added-item');
        const selectedBundle = this.querySelector('.bundle-pack-drawer-item.wide-active');
        const selectedBundleQty = parseInt(selectedBundle.getAttribute('data-count'));
        let bottomContent = '';
        let savedAmount = 0;
        let totalAmount = 0;

        if(addedItems.length > 0){

            if(selectedBundleQty == addedItems.length){
                addedItems.forEach((addedItem) => {
                    const vPrice = parseFloat(addedItem.getAttribute('data-price'));
                    const vdPrice = this.getDiscountedPrice(vPrice);
                    const priceOffset = vPrice - vdPrice;

                    savedAmount += priceOffset;
                    totalAmount += vdPrice;
                })

                bottomContent += '<div class="bundle-pack-bottom-wrap">';
                bottomContent += `<div class="bundle-pack-bottom-s-line"><span class="s-title">You Saved</span><span class="s-price">$${this.formatMoney(savedAmount, "{{amount}}")}</span></div>`;
                bottomContent += `<div class="bundle-pack-bottom-t-line"><span class="t-title">Total</span><span class="t-price">$${this.formatMoney(totalAmount, "{{amount}}")}</span></div>`;
                bottomContent += '<div class="bundle-pack-bottom-button"><button type="button" class="button button--full-width js-bp-checkout">Add Discounted Bundle to Cart</button></div>';
                bottomContent += '</div>';

                this.packBottom.innerHTML = bottomContent;
                this.pairWrapContent.classList.add('hidden');
                this.pairTitle.classList.add('hidden');
            }else{
                this.packBottom.innerHTML = '';
                this.pairWrapContent.classList.remove('hidden');
                this.pairTitle.classList.remove('hidden');
            }
        }else{
            this.packBottom.innerHTML = '';
            this.pairWrapContent.classList.remove('hidden');
            this.pairTitle.classList.remove('hidden');
        }
    }

    getDiscountedPrice(price){
        const selectedBundle = this.querySelector('.bundle-pack-drawer-item.wide-active');
        const selectedBundleQty = parseInt(selectedBundle.getAttribute('data-count'));
        const selectedBundleDiscount = bundlePackSize.find((bundlePackSizeItem) => bundlePackSizeItem.count == selectedBundleQty).discount;
        
        return price * selectedBundleDiscount / 100;
    }

    getSelectedProduct(){
        const selectedProductID = this.querySelector('.bundle-pack-drawer-icon.active').getAttribute('data-productid');
        const selectedProduct = products.find((product) => product.id == parseInt(selectedProductID));

        if(!selectedProduct) return false;

        return selectedProduct;
    }

    getSelectedVariant(){
        this.selectedoptions = Array.from(this.querySelectorAll('select.option'), (select) => select.value);

        if(this.getSelectedProduct()){
            this.selectedVariant = this.getSelectedProduct().variants.find((variant) => {
                return !variant.options.map((option, index) => {
                    return this.selectedoptions[index] === option;
                }).includes(false);
            });

            if(!this.selectedVariant) return false;

            return this.selectedVariant;
        }else{
            return false;
        }
    }
}

customElements.define('pack-drawer', PackDrawer);